/**
 * UI-whitelist: hvilke subject_type-værdier der må vise/redigere DK forberedelsesfaktor
 * (deactivatePools + skole DK). Bruges ikke til vægtning i preparationFactor.js — kun formular-gates.
 */

import {parseNumericPreparationFactor, clampDanishPreparationFactor} from './preparationFactor'

export const DK_PREPARATION_FACTOR_SUBJECT_TYPES = [
  'subject',
  'activity',
  'person_resource',
  'person_resource_visible',
  'optional',
  'supplemental',
  'preparation'
]

export function isSubjectTypeWithDanishPreparationFactor (subjectType) {
  return DK_PREPARATION_FACTOR_SUBJECT_TYPES.indexOf(subjectType) > -1
}

/** Skolen har en konfigureret forberedelsesfaktor (til visning af DK-felt / prep-toggle). */
export function schoolHasDanishPreparationFactorConfigured (schoolSettings) {
  if (!schoolSettings) {
    return false
  }
  return parseNumericPreparationFactor(schoolSettings.prepFactor) !== null
}

/** Forberedelsesopgaver: kun null (standard) eller 1 (eksplicit) i UI og payload. */
export function isDanishPreparationBinaryPrepTaskSubjectType (subjectType) {
  return subjectType === 'preparation'
}

export function normalizeDanishPreparationForPrepTask (value) {
  const n = parseNumericPreparationFactor(value)
  if (n === 1) {
    return 1
  }
  return null
}

/**
 * Normaliser preparation-værdien inden save/API-kald.
 * @param {*} value – rå formularværdi (this.preparation)
 * @param {boolean} isShowField – om DK-forberedelsesfaktoren vises i formularen
 * @param {string} subjectType – subject_type på faget/opgaven
 */
export function preparationPayloadForSave (value, isShowField, subjectType) {
  if (!isShowField) {
    return value
  }
  if (isDanishPreparationBinaryPrepTaskSubjectType(subjectType)) {
    return normalizeDanishPreparationForPrepTask(value)
  }
  return clampDanishPreparationFactor(value)
}

/**
 * Konverter API-værdien til en formularvenlig værdi.
 * @param {*} prep – preparation fra API
 * @param {boolean} isShowField – om DK-forberedelsesfaktoren vises i formularen
 * @param {string} subjectType – subject_type på faget/opgaven
 */
export function preparationFromApiForForm (prep, isShowField, subjectType) {
  if (prep == null) {
    return null
  }
  const n = prep * 1
  if (!isShowField) {
    return n
  }
  if (isDanishPreparationBinaryPrepTaskSubjectType(subjectType)) {
    return normalizeDanishPreparationForPrepTask(n)
  }
  return clampDanishPreparationFactor(n)
}



// WEBPACK FOOTER //
// ./src/utils/dkPreparationFactorUi.js